import React from 'react';
import { Link } from 'react-router-dom';
import { Helper } from '../static/helper';

import imgSeniors from '../images/Seniors.jpeg';
import imgSportifs from '../images/trail-running.webp';
import imgActifs from '../images/Actifs.jpeg';
import imgEnfants from '../images/Enfants.jpeg';

import imgAlexis from '../images/Alexis.JPG';
import imgEmilie from '../images/Emilie.JPG';

const Services = () => {

    return (
        <div id="services" className="bg-gray-100 py-12">
            {/* Section: La chiropraxie pour qui ? */}
            <section aria-labelledby="services-title" data-aos="zoom-in-down">
                <div className="my-4 py-4 px-4">
                    <h2 id="services-title" className="my-2 text-center text-3xl sm:text-4xl lg:text-5xl font-bold" style={{ color: Helper.footerBackGroundColor }}>
                        La chiropraxie pour qui ?
                    </h2>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 mt-4' style={{ borderColor: Helper.footerBackGroundColor }} role="presentation"></div>
                    </div>
                </div>

                <div className="px-4 sm:px-8 lg:px-12" data-aos="fade-down" data-aos-delay="600">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">

                        <Link to="/ConsultationQui" className="bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 group" aria-label="En savoir plus sur la chiropraxie pour les actifs">
                            <div className="h-40 overflow-hidden">
                                <img
                                    alt="Personne active au travail"
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    src={imgActifs}
                                    loading="lazy"
                                    width="300"
                                    height="160"
                                />
                            </div>
                            <div className="p-4">
                                <h3 className="font-bold text-xl text-center mb-2" style={{ color: Helper.footerBackGroundColor }}>Actifs</h3>
                                <p className="text-gray-600 text-sm text-center">
                                    Prévenir et soulager les douleurs du quotidien
                                </p>
                            </div>
                        </Link>

                        <Link to="/ConsultationQui" className="bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 group" aria-label="En savoir plus sur la chiropraxie pour les sportifs">
                            <div className="h-40 overflow-hidden">
                                <img
                                    alt="Sportif en course à pied"
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    src={imgSportifs}
                                    loading="lazy"
                                    width="300"
                                    height="160"
                                />
                            </div>
                            <div className="p-4">
                                <h3 className="font-bold text-xl text-center mb-2" style={{ color: Helper.footerBackGroundColor }}>Sportifs</h3>
                                <p className="text-gray-600 text-sm text-center">
                                    Améliorer les performances et prévenir les blessures
                                </p>
                            </div>
                        </Link>

                        <Link to="/ConsultationQui" className="bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 group" aria-label="En savoir plus sur la chiropraxie pour les seniors">
                            <div className="h-40 overflow-hidden">
                                <img
                                    alt="Couple de seniors actifs"
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    src={imgSeniors}
                                    loading="lazy"
                                    width="300"
                                    height="160"
                                />
                            </div>
                            <div className="p-4">
                                <h3 className="font-bold text-xl text-center mb-2" style={{ color: Helper.footerBackGroundColor }}>Séniors</h3>
                                <p className="text-gray-600 text-sm text-center">
                                    Entretenir la mobilité et ralentir l'arthrose
                                </p>
                            </div>
                        </Link>

                        <Link to="/ConsultationQui" className="bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 group" aria-label="En savoir plus sur la chiropraxie pour les enfants">
                            <div className="h-40 overflow-hidden">
                                <img
                                    alt="Enfants jouant"
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    src={imgEnfants}
                                    loading="lazy"
                                    width="300"
                                    height="160"
                                />
                            </div>
                            <div className="p-4">
                                <h3 className="font-bold text-xl text-center mb-2" style={{ color: Helper.footerBackGroundColor }}>Enfants</h3>
                                <p className="text-gray-600 text-sm text-center">
                                    Suivi précoce du nourrisson à l'adolescence
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </section>

            {/* Section: Qui sommes-nous ? */}
            <section aria-labelledby="team-title" className="mt-16">
                <div className="m-auto max-w-6xl p-4 md:p-12">
                    <h2 id="team-title" className="my-2 text-center text-3xl sm:text-4xl lg:text-5xl font-bold" style={{ color: Helper.footerBackGroundColor }}>
                        Qui sommes-nous ?
                    </h2>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4 mt-4' style={{ borderColor: Helper.footerBackGroundColor }} role="presentation"></div>
                    </div>
                    <div className="flex flex-col sm:flex-row py-8 justify-center gap-12" data-aos="zoom-out">
                        <article className="flex flex-col justify-center items-center">
                            <div className="w-40 h-40 sm:w-48 sm:h-48 rounded-full overflow-hidden shadow-xl">
                                <img
                                    alt="Portrait d'Emilie Gouache, chiropracteur"
                                    className="w-full h-full object-cover"
                                    src={imgEmilie}
                                    loading="lazy"
                                    width="192"
                                    height="192"
                                />
                            </div>
                            <h3 style={{ color: Helper.footerBackGroundColor }} className="text-xl sm:text-2xl font-bold mt-4">Emilie Gouache</h3>
                            <p className="text-gray-500 text-sm">Chiropracteur</p>
                        </article>
                        <article className="flex flex-col justify-center items-center">
                            <div className="w-40 h-40 sm:w-48 sm:h-48 rounded-full overflow-hidden shadow-xl">
                                <img
                                    alt="Portrait d'Alexis Moulin, chiropracteur"
                                    className="w-full h-full object-cover"
                                    src={imgAlexis}
                                    loading="lazy"
                                    width="192"
                                    height="192"
                                />
                            </div>
                            <h3 style={{ color: Helper.footerBackGroundColor }} className="text-xl sm:text-2xl font-bold mt-4">Alexis Moulin</h3>
                            <p className="text-gray-500 text-sm">Chiropracteur</p>
                        </article>
                    </div>
                </div>
                <div className="m-auto max-w-3xl px-4">
                    <p className='text-base sm:text-lg text-gray-600 text-center'>
                        Tous deux formés par l'Institut Franco Européen de Chiropraxie (IFEC), nous continuons de nous former pour avoir un large panel de techniques et nous adapter au maximum à nos patients.
                    </p>
                </div>
                <div className="flex justify-center mt-8">
                    <Link
                        to="/Praticiens"
                        style={{ background: Helper.footerBackGroundColor }}
                        className="text-white font-semibold rounded-xl px-8 py-3 hover:opacity-90 transition-opacity shadow-lg"
                        aria-label="En savoir plus sur nos chiropracteurs Emilie et Alexis"
                    >
                        En savoir plus
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Services;
